import { Grid } from "@material-ui/core";
import React, { useState } from "react";
import CategoryIcon from "../CategoryIcon";
import Popper from '@mui/material/Popper';
import Typography from '@mui/material/Typography';
import Skeleton from '@mui/material/Skeleton';
import Paper from '@mui/material/Paper';

const convertValueToIcons = (category, handlePopoverOpen, handlePopoverClose, anchorEl, open, id) => {
  if (!category || !category.value || category.value.length === 0) {
    return null;
  }

  return category.value.map((visit, visitIndex) => {
    let icon = visit.value !== 'NA' ? visit.value : '';
    if (icon && category.comments) {
      icon += '_notes';
    }

    return (
      <tr key={visitIndex}>
        <td className="">
          {visit.value !== "NA" ? (
            <div
              onMouseEnter={category.comments ? (event) => handlePopoverOpen(event) : null}
              onMouseLeave={category.comments ? handlePopoverClose : null}
            >
              <CategoryIcon category={icon} />
            </div>
          ) : (
            <h5 style={{ marginTop: '1em' }}>N/A</h5>
          )}
          {category.comments && visit.value !== "NA" && (
            <Popper
              id={id}
              open={open}
              anchorEl={anchorEl}
              placement="bottom"
              disablePortal
            >
              <Paper
                sx={{
                  padding: '10px',
                  backgroundColor: '#f5f5f5',
                  borderRadius: '4px',
                  maxWidth: '200px',
                  textAlign: 'center',
                }}
              >
                <Typography variant="body2">
                  {category.comments || ''}
                </Typography>
              </Paper>
            </Popper>
          )}
        </td>
      </tr>
    );
  });
};

const SafetyPastVisits = ({ previousCategoryInspection, date, index, loadingVisits, isPreviousInspectionLoaded }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'mouse-over-popper' : undefined;

  return (
    <Grid container justifyContent="center">
      <table className="lastVisitsTable" style={{ border: 0, width: "auto" }}>
        <thead>
          {index === 0 && (
            <>
              <tr>
                <th className="header-cell" colSpan="2" style={{ height: "30px" }}>
                  {date ? date : !isPreviousInspectionLoaded ? 'Loading' : 'No Previous'}
                </th>
              </tr>
              <tr>
                <th className="header-cell">Inspection</th>
              </tr>
            </>
          )}
        </thead>
        <tbody className={`lastvisits-body ${index !== 0 ? "icon-cell" : ""}`}>
          {loadingVisits ? (
            <tr>
              <td className="table-cell-img">
                <Skeleton
                  variant="circular"
                  width={50}
                  height={50}
                  className="table-cell-img"
                  animation={"pulse"}
                  style={{ visibility: !isPreviousInspectionLoaded ? "visible" : "hidden" }}
                />
              </td>
            </tr>
          ) : (
            convertValueToIcons(previousCategoryInspection, handlePopoverOpen, handlePopoverClose, anchorEl, open, id)
          )}
        </tbody>
      </table>
    </Grid>
  );
};

export default SafetyPastVisits;
